import React, { useMemo } from 'react';
import GivelifyModal from '../../../../theme/GivelifyModal';
import { useSelector } from 'react-redux';
import { AppState } from '../../../../store';
import { useTranslation } from 'react-i18next';
import { EditButton } from '../EditUserInfoModal';
import { EditForm } from './EditForm';

interface EditOrganizationInfoModalProps {
    open: boolean;
    setOpen: (open: boolean) => unknown;
}

const EditOrganizationInfoModal: React.FC<EditOrganizationInfoModalProps> = ({
    open,
    setOpen,
}) => {
    const { signUp } = useSelector((state: AppState) => ({
        signUp: state.Signup,
    }));
    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    const { t } = useTranslation();
    const copy = useMemo(
        () => ({
            editInfo: t('signup.reviewStep.editInfo'),
            organizationModalText: t('signup.reviewStep.organizationModalText'),
        }),
        [t],
    );

    return (
        <>
            <EditButton handleOpen={handleOpen}>{copy.editInfo}</EditButton>

            <GivelifyModal
                label={copy.organizationModalText}
                isOpen={open}
                handleClose={handleClose}
                disableBackdropClick
                disableClose
            >
                <EditForm signUp={signUp} handleClose={handleClose} />
            </GivelifyModal>
        </>
    );
};

export default EditOrganizationInfoModal;
